import { ProjectApiModel } from 'app/models/projects-api.model';
import * as projectsActions from '../actions/projects.actions';
import { setActiveCompany } from '@core/auth/@store/user/user.actions';
import { on, Action, createReducer } from '@ngrx/store';

export interface State {
  projects: ProjectApiModel[];
  totalProjects: number;
  isLoading: boolean;
  isReady: boolean;
  isSaving: boolean;
}

export const initialState: State = {
  projects: [],
  totalProjects: 0,
  isLoading: false,
  isReady: false,
  isSaving: false,
};

const featureReducer = createReducer(
  initialState,
  on(projectsActions.loadProjects, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(projectsActions.loadProjectsSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    projects: response.results,
    totalProjects: response.count,
  })),
  on(projectsActions.createProject, projectsActions.updateProject, (state) => ({
    ...state,
    isSaving: true,
  })),
  on(
    projectsActions.createProjectSuccess,
    projectsActions.createProjectFailed,
    projectsActions.updateProjectSuccess,
    projectsActions.updateProjectFailed,
    (state) => ({
      ...state,
      isSaving: false,
    })
  ),
  on(
    projectsActions.resetProjects,
    setActiveCompany,
    (state: State) => initialState
  )
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
